import React, { Component } from "react";  
  
import available from '../../../src/assets/icons/available.png';
import notavailable from '../../../src/assets/icons/notavailable.png';
import notapplicable from '../../../src/assets/icons/notapplicable.png';
const amenImageGrabber = (type,facilites) => {
  type = type.toLowerCase().trim();

  var split_str = facilites.split(",");
  
  let typeu = type.toUpperCase();

  split_str.forEach(element => {
    
        if(element===typeu){
          return '../../../src/assets/icons/available.png';
        }else{
          return '../../../src/assets/icons/notavailable.png';
        } 
   });
   
}; 



class Comp5 extends Component {  
  constructor() {  
    super();  
    this.state = {  
      name: "ReactJS",
      facilites: '',
      defaultfacilites:'AC Classes,CCTV,Food and Snacks,Outdoor Play area,Transportation',
      defaultfacilites2:'transportation,food and snacks'
    };  
  }  

   componentDidMount() {

      let info = this.props.paraminfo;
     
      this.setState({facilites:info});


   }

   
  render() {  
    return <div id="amenities_section"><h3>Amenities</h3> <span style={{fontSize:"9px"}}> <img src={available} width="16px" />Available &nbsp;<img src={notavailable} width="16px" />Not Available &nbsp;<img src={notapplicable} width="16px" />Not Applicable &nbsp;</span>
          <div class="amenitiesinfo container">
                <div className='row n6c3d desktop'>
                <div class="row n6c3d desktop">
                    <div class="col-md-6">
                      <div class="type-icon2">
                        <img src={(this.state.facilites.indexOf('AC Classes')!=-1)? available:notavailable} alt="AC Classes" />
                      </div>
                        <div class="key-icon2" style={{textTransform: "capitalize"}}>
                          <p>AC Classes</p>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="type-icon2">
                          <img src={(this.state.facilites.indexOf('CCTV')!=-1)? available:notavailable} alt="CCTV" />
                        </div>
                        <div class="key-icon2" style={{textTransform: "capitalize"}}>
                          <p>CCTV</p></div></div><div class="col-md-6"><div class="type-icon2">
                            <img src={(this.state.facilites.indexOf('Food and Snacks')!=-1)? available:notavailable} alt="Food and Snacks" /></div>
                            <div class="key-icon2" style={{textTransform: "capitalize"}}><p>Food and Snacks</p></div></div>
                            <div class="col-md-6"><div class="type-icon2">
                              <img src={(this.state.facilites.indexOf('Outdoor Play area')!=-1)? available:notavailable} alt="Outdoor Play area" /></div>
                              <div class="key-icon2" style={{textTransform: "capitalize"}}><p>Outdoor Play area</p></div>
                              </div><div class="col-md-6"><div class="type-icon2">
                                <img src={(this.state.facilites.indexOf('Transportation')!=-1)? available:notavailable} alt="Transportation" /></div>
                                <div class="key-icon2" style={{textTransform: "capitalize"}}><p>Transportation</p></div></div></div>
                </div>
                <div className='mobileblock'>
                <div className='cardblock'  >
                                    
                                    <img src={(this.state.facilites.indexOf('AC Classes')!=-1)? available:notavailable} alt="AC Classes" /> &nbsp; AC Classes
                                  
                                  
                </div>  
                <div className='cardblock'  >
                                    
                <img src={(this.state.facilites.indexOf('CCTV')!=-1)? available:notavailable} alt="CCTV" />&nbsp; CCTV
                                  
                                  
                </div>  
                <div className='cardblock'  >
                                    
                <img src={(this.state.facilites.indexOf('Food and Snacks')!=-1)? available:notavailable} alt="Food and Snacks" />&nbsp; Food and Snacks
                             
                                  
                </div>  
                <div className='cardblock'  >
                                    
                <img src={(this.state.facilites.indexOf('Outdoor Play area')!=-1)? available:notavailable} alt="Outdoor Play area" />&nbsp; Outdoor Play area
                             
                                  
                </div>  
                <div className='cardblock'  >
                                    
                <img src={(this.state.facilites.indexOf('Transportation')!=-1)? available:notavailable} alt="Transportation" />&nbsp; Transportation
                             
                                  
                </div>                                                           
                </div>
          </div>
         </div>
  }  
}  
   
export default Comp5;